import { useRef } from "react"; 
import Proptypes from "prop-types";

import { CloseRounded } from "@mui/icons-material";
import { Button, IconButton, Fade, Modal } from "@mui/material";

import { ModalText } from "./ModalText";
import { ModalSign } from "./ModalSign";
import { useContext } from "react";
import { SignatureContext } from "../../../context/SignatureContext";
import { ModalDate } from "./ModalDate";
import { TYPES } from "../../../../../config/constants/typesReducers";
import { useState } from "react";
import { pascalCase } from "pascal-case";
import { formatISODate } from "../../../../../ui/utils/dateFormat";

export const ModalField = ({ field, sign, openModal, handleClose }) => {
    const { signatureDispatch } = useContext(SignatureContext);
    const [value, setValue] = useState(field.value);

    const elementRef = useRef(null);

    const getModalByType = (type) => {
        switch (type) {
            case 'sign': return ModalSign;
            case 'date': return ModalDate;
            default: return ModalText;
        }
    }

    const TypeModal = getModalByType(field.type);

    const handleSave = () => {
        if (field.type === 'sign' && !value) return;
        
        // Para campos de fecha, convertir de ISO (yyyy-MM-dd) al formato configurado
        const savedValue = (field.type === 'date' && value)
            ? formatISODate(value, field.dateFormat)
            : value;

        const action = {
            type: TYPES.SIGNATURE.EDIT_FIELDS,
            payload: {
                field,
                value: savedValue
            }
        }
        signatureDispatch(action);
        handleClose();
    };
    return (
        <Modal 
            disableEnforceFocus
            disableAutoFocus
            disableRestoreFocus
            open={openModal}
            onClose={handleClose}
            closeAfterTransition>
                <Fade  
                    timeout={100}
                    in={openModal}>
                    <div 
                        className="field__modal">
                            <IconButton
                                    onClick={handleClose}
                                    size="small"
                                    style={{
                                        position: 'absolute',
                                        top: '15px',
                                        right: '15px',
                                    }}
                                >
                                    <CloseRounded />
                                </IconButton>

                            <p className="black-text xxl-text bold-text mb-2">{{ 'sign': 'Firma', 'date': 'Fecha', 'text': 'Texto' }[field.type] ?? pascalCase(field.type)}</p>
                            <p className="grey-text md-text">Rellena el siguiente campo</p>
                            <br />
                            {
                                <TypeModal 
                                    elementRef={elementRef} 
                                    value={value}
                                    sign={sign}
                                    setValue={setValue}
                                    dateFormat={field.dateFormat}/>
                            }
                            <br />
                            <div
                                style={{
                                    textAlign: 'end',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                                >
                                <Button
                                    onClick={handleClose}
                                    disableElevation
                                    color="secondary"
                                    style={{marginRight:'10px'}}>
                                        Atrás
                                </Button>
                                <Button
                                    onClick={handleSave}
                                    variant="contained"
                                    disabled={!value}
                                    disableElevation
                                    color="primary">
                                        Guardar
                                </Button>
                            </div>
                    </div>
                </Fade>
        </Modal>
)}

ModalField.propTypes = {
    field: Proptypes.object,
    openModal: Proptypes.bool,
    setOpenModal: Proptypes.func,
    setSignature: Proptypes.func,
    handleClose: Proptypes.func,
    sign: Proptypes.string,

}